/**
 * Eikaiwa is consistantly special, so there wasn't a great way to completely do away with knowing
 * about the domain.
 */
export const EIKAIWA_DOMAIN = 'eikaiwa.dmm.com';
export const EIKAIWA_ADMIN_DOMAIN = `admin.${EIKAIWA_DOMAIN}`;
